import { render, staticRenderFns } from "./ferryOrder-info.vue?vue&type=template&id=045b9691&scoped=true"
import script from "./ferryOrder-info.vue?vue&type=script&lang=js"
export * from "./ferryOrder-info.vue?vue&type=script&lang=js"
import style0 from "./ferryOrder-info.vue?vue&type=style&index=0&id=045b9691&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b9691",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045b9691')) {
      api.createRecord('045b9691', component.options)
    } else {
      api.reload('045b9691', component.options)
    }
    module.hot.accept("./ferryOrder-info.vue?vue&type=template&id=045b9691&scoped=true", function () {
      api.rerender('045b9691', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/intercity/components/ferryOrder-info.vue"
export default component.exports